import React from "react";

const steps = [
  { n: "01", t: "Consult", b: "We listen first — understanding your vision, site, brief, and budget.", img: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
  { n: "02", t: "Design", b: "Architectural concepts and detailed drafts shaped around how you'll live or work.", img: "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
  { n: "03", t: "Approve", b: "We refine together until every line on the plan is exactly right.", img: "https://images.pexels.com/photos/37582309/pexels-photo-37582309.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { n: "04", t: "Build", b: "On-site delivery managed end-to-end, handed over with precision.", img: "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
];

export default function Process() {
  return (
    <section id="process" data-testid="section-process" className="bg-bone py-24 md:py-40 border-t border-ink/10">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-8 mb-20 reveal">
          <p className="label col-span-12 md:col-span-2">06 — How we work</p>
          <h2 className="display col-span-12 md:col-span-9 text-[9vw] md:text-6xl lg:text-[5rem] leading-[0.98] tracking-tighter">
            A four-step process,  <span className="italic font-light text-rust">built for clarity.</span>
          </h2>
        </div>

        <div className="space-y-0">
          {steps.map((s, i) => (
            <article
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="reveal grid grid-cols-12 gap-6 md:gap-10 items-center py-10 md:py-16 border-t border-ink/15"
            >
              <p className="display italic text-[18vw] md:text-[10rem] text-rust/15 leading-none col-span-12 md:col-span-2">{s.n}</p>
              <div className="col-span-12 md:col-span-5">
                <p className="label mb-3">Step {s.n}</p>
                <h3 className="display text-5xl md:text-6xl lg:text-7xl">{s.t}</h3>
                <p className="mt-5 text-base md:text-lg text-muted2 max-w-lg leading-relaxed">{s.b}</p>
              </div>
              <div className={`col-span-12 md:col-span-5 overflow-hidden aspect-[5/3] ${i % 2 ? "md:translate-y-6" : "md:-translate-y-2"}`}>
                <img src={s.img} alt={s.t} className="w-full h-full object-cover transition-transform duration-[1500ms] hover:scale-105" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
